// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"SideBar_sidebar__2o53r","logo":"SideBar_logo__1N47u","list":"SideBar_list__2k4At","userImage":"SideBar_userImage__apE0X"};